import { Injectable, inject } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { AccessibleMiddleware, MiddlewareService, ProfileMiddleware } from '@mediahaven/shared';
import { ApiFragment } from '@stylehaven/components';
import PortalContextMiddleware from './context.middleware';

@Injectable({ providedIn: 'root' })
export default class AggregateMiddleware implements MiddlewareService {
    private contextMiddleware: PortalContextMiddleware = inject(PortalContextMiddleware);
    constructor(private profileMiddleware: ProfileMiddleware, private accessibleMiddleWare: AccessibleMiddleware) {}

    annotate(record: ApiFragment): Observable<ApiFragment> {
        return this.accessibleMiddleWare.annotate(record).pipe(
            switchMap(acccessibleRecord => this.contextMiddleware.annotate(acccessibleRecord)),
            switchMap(accessibleRecord => this.profileMiddleware.annotate(accessibleRecord)),
            catchError(error => {
                return throwError(error);
            })
        );
    }
}
